module.exports = __webpack_public_path__ + "img/box7-2.e855312d.png";